"use strict";

angular.module("imagetrend.components").directive("hlpEditHistory", [
    function() {
        return {
            restrict: "AE",
            scope: {
                //attributes
                record: "=?",
                revertTimezone: "=?",
                showModified: "=?",
                deleted: "=?"
            },
            replace: true,
            transclude: true,
            templateUrl: "templates/edit-history/edit-history.html",
            link: function(scope, elem, attrs, ctrl) {
                // if (record) console.log(record);
            }
        };
    }
]);
